import { render, staticRenderFns } from "./third.vue?vue&type=template&id=67631316&scoped=true&"
import script from "./third.vue?vue&type=script&lang=js&"
export * from "./third.vue?vue&type=script&lang=js&"
import style0 from "./third.vue?vue&type=style&index=0&id=67631316&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67631316",
  null
  
)

export default component.exports